import api from "~/services/api";

export const postFeed = (data) => {
	return api.post(`/feed`, data);
};

export default {
	postFeed,
};
